module.exports = __webpack_public_path__ + "static/media/1.8df2c1f9.jpg";